import ServiceForm from "./form";
import { AttendanceLocalService } from "../../../../../../../@types/attendance-local-service";
import { useAttendanceLocalServiceUpdate } from "../../../../../../../services/api-tansquery/attendance-local/service/update";

type ServiceFormProps = {
    slug: string;
    service: AttendanceLocalService;
    buttonTrigger?: React.ReactNode;
};

export default function ServiceFormUpdate(props: ServiceFormProps) {
    const mutation = useAttendanceLocalServiceUpdate(props.service.id);

    return (
        <ServiceForm
            {...props}
            mutation={mutation}
        />
    );
}
